export function sidebarClipboardCopyFailedTitle(target: string) {
  return `${target} could not be copied`
}

export function sidebarClipboardCopyFailedMessage() {
  return "Clipboard access is unavailable. Check browser permissions and try again."
}
